<script setup lang="ts">
import {onBeforeMount, onUnmounted, ref} from "vue";
import CloseIcon from "@/components/icons/toastIcons/CloseIcon.vue";
import {useNotificationsStore} from "@/stores/ToastDataStore";
import NamaCommon from "@/utils/common/NamaCommon";
import {useInterval} from "@vueuse/core";
import Translator from "@/utils/common/Translator.ts";

const userNotifications: namaTypes.DTOUserNotification[] = [];
const props = defineProps<{ notifications: namaTypes.DTOTabularResult[] }>();

onBeforeMount(() => {
  if (props.notifications && props.notifications.length) {
    for (let n of props.notifications) {
      let nConv: namaTypes.DTOUserNotification = {};
      userNotifications.push(Object.assign(nConv, n.values));
    }
  }
})

onUnmounted(() => {
  useNotificationsStore().clearNotifications();
})

function calcTimeDiff(notification: namaTypes.DTOUserNotification) {
  let timeDiff = ref(NamaCommon.getDateDifferenceAsString(notification.submittedOn!));
  useInterval(60000, {
    callback(count) {
      timeDiff.value = NamaCommon.getDateDifferenceAsString(notification.submittedOn!);
    },
  });
  return timeDiff;
}
</script>

<template>
  <div class="tw-flex tw-flex-col tw-w-full">
    <q-avatar square :title="Translator.translateId('close')" data-close-btn class="tw-size-4 tw-shrink-0 tw-cursor-pointer">
      <CloseIcon class="tw-w-[14px] tw-fill-gray-600 dark:tw-fill-gray-300 hover:tw-fill-gray-700 hover:dark:tw-fill-gray-400 tw-divide-opacity-80"/>
    </q-avatar>
    <div class="tw-max-h-[60vh] tw-overflow-y-auto tw-pe-2">
      <div
        class="tw-grow tw-flex tw-flex-col tw-justify-between tw-w-full tw-gap-2 tw-overflow-y-auto tw-max-h-[40vh]"
        v-for="(un, index) in userNotifications"
        :key="index">
        <div class="tw-w-full tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center">
          <div v-if="un.subject || un.submittedOn" :class="{'tw-justify-between':un.body,'tw-justify-end':!un.body}"
               class="tw-w-full tw-flex tw-sticky tw-top-[-1px] tw-bg-gray-300  dark:tw-bg-gray-600  tw-items-center tw-pb-1 tw-text-white">
            <div v-if="un.body" v-html="un.subject" class="tw-text-white tw-font-bold nama-notification-body tw-text-[16px]"/>
            <span v-text="calcTimeDiff(un)" class="tw-font-normal tw-text-gray-600 dark:tw-text-gray-300 tw-text-[12px]"
                  :class="{'tw-self-end':un.submittedOn}"/>
          </div>
          <div class="tw-w-full tw-grow tw-break-words" v-if="un.body||un.subject">
            <div class="tempo-tooltip-content"
                 v-html="un.body??un.subject"/>
          </div>
        </div>
        <hr class="tw-w-full tw-sticky tw-bottom-0" v-if="index<userNotifications.length-1">
      </div>
    </div>
  </div>
</template>

<style>

</style>
